const generateRange = (start, end) =>
  Array(Math.abs(start - end) + 1)
    .fill(start)
    .map(start < end ? (v, i) => v + i : (v, i) => v - i)

export default generateRange
